import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconPoll: React.FC<IconProps> = ({ width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
        >
            <path
                d="M2.06283 15.6046H5.18783C5.47585 15.6046 5.70866 15.3713 5.70866 15.0838C5.77793 14.2437 5.56178 13.3843 4.86543 12.8989C5.65658 11.9348 4.88418 10.3557 3.62533 10.3963C2.36699 10.3567 1.59355 11.9343 2.38522 12.8989C1.87637 13.2791 1.54199 13.8801 1.54199 14.5629V15.0838C1.54199 15.3713 1.7748 15.6046 2.06283 15.6046ZM2.58366 14.5629C2.60814 13.1937 4.64251 13.1942 4.66699 14.5629H2.58366ZM3.10449 11.9588C3.10814 11.278 4.14303 11.278 4.14616 11.9588C4.14251 12.6395 3.10762 12.6395 3.10449 11.9588Z"
                fill="black"
            />
            <path
                d="M2.06283 9.35461H5.18783C5.47585 9.35461 5.70866 9.12128 5.70866 8.83378C5.77793 7.99367 5.56178 7.1343 4.86543 6.64888C5.65658 5.68482 4.88418 4.10565 3.62533 4.14628C2.36699 4.10669 1.59355 5.6843 2.38522 6.64888C1.87637 7.02909 1.54199 7.63013 1.54199 8.31294V8.83378C1.54199 9.12128 1.7748 9.35461 2.06283 9.35461ZM2.58366 8.31294C2.60814 6.94367 4.64251 6.94419 4.66699 8.31294H2.58366ZM3.10449 5.70878C3.10814 5.02805 4.14303 5.02805 4.14616 5.70878C4.14251 6.38951 3.10762 6.38951 3.10449 5.70878Z"
                fill="black"
            />
            <path
                d="M2.06283 21.8546H5.18783C5.47585 21.8546 5.70866 21.6213 5.70866 21.3338C5.77793 20.4937 5.56178 19.6343 4.86543 19.1489C5.65658 18.1848 4.88418 16.6057 3.62533 16.6463C2.36699 16.6067 1.59355 18.1843 2.38522 19.1489C1.87637 19.5291 1.54199 20.1301 1.54199 20.8129V21.3338C1.54199 21.6213 1.7748 21.8546 2.06283 21.8546ZM2.58366 20.8129C2.60814 19.4437 4.64251 19.4442 4.66699 20.8129H2.58366ZM3.10449 18.2088C3.10814 17.528 4.14303 17.528 4.14616 18.2088C4.14251 18.8895 3.10762 18.8895 3.10449 18.2088Z"
                fill="black"
            />
            <path
                d="M6.22949 18.7295V19.7712C6.22949 20.6326 6.93053 21.3337 7.79199 21.3337H18.7295C21.479 21.2477 21.4852 17.255 18.7295 17.167H7.79199C6.93053 17.167 6.22949 17.868 6.22949 18.7295ZM19.7712 19.2503C19.7712 19.8248 19.304 20.292 18.7295 20.292H7.79199C7.50449 20.292 7.27116 20.0581 7.27116 19.7712V18.7295C7.27116 18.4425 7.50449 18.2087 7.79199 18.2087H18.7295C19.304 18.2087 19.7712 18.6758 19.7712 19.2503Z"
                fill="black"
            />
            <path
                d="M11.4378 10.917H7.79199C6.93053 10.917 6.22949 11.618 6.22949 12.4795V13.5212C6.22949 14.3826 6.93053 15.0837 7.79199 15.0837H11.4378C14.1899 14.9967 14.1915 11.0045 11.4378 10.917ZM11.4378 14.042H7.79199C7.50449 14.042 7.27116 13.8081 7.27116 13.5212V12.4795C7.27116 12.1925 7.50449 11.9587 7.79199 11.9587H11.4378C12.8055 11.9826 12.8076 14.0175 11.4378 14.042Z"
                fill="black"
            />
            <path
                d="M22.3753 4.66699H7.79199C6.93053 4.66699 6.22949 5.36803 6.22949 6.22949V7.27116C6.22949 8.13262 6.93053 8.83366 7.79199 8.83366H22.3753C25.1238 8.74824 25.1321 4.75501 22.3753 4.66699ZM22.3753 7.79199H7.79199C7.50449 7.79199 7.27116 7.55814 7.27116 7.27116V6.22949C7.27116 5.94251 7.50449 5.70866 7.79199 5.70866H22.3753C23.7389 5.73158 23.7482 7.76699 22.3753 7.79199Z"
                fill="black"
            />
        </svg>
    );
};

export default IconPoll;
